import { unaryRpc } from "@redotech/rpc/definition";
import * as z from "zod";

export const subscribeToTrackingSms = unaryRpc({
  name: "subscribeToTrackingSms",
  input: z.object({ phoneNumber: z.string() }),
  output: z.object({ success: z.boolean(), error: z.string().optional() }),
});
